import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_coastal_vibes: FaireThemeEntity = {
  token: "discovery_theme_coastal-vibes",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Coastal Vibes",
  description: "Breezy, ocean-inspired home goods",
  bgColor: "#D4E8F0",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
